// extracted by mini-css-extract-plugin
export default {"buyButton":"Card_buyButton__Cbney","profileContainer":"Card_profileContainer__FikYU","cardContainer":"Card_cardContainer__jhYGA","thumbImageCard":"Card_thumbImageCard__QCmuc"};